import { cva } from '@/styled-system/css';

export const adornedInputRecipe = cva({
  base: {
    'backgroundColor': {
      base: 'AdornedInput.bg.default',
    },
    'cursor': 'text',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
    },
    'boxShadowColor': {
      base: 'AdornedInput.border.default',
    },
    'textStyle': 'body',
    '&:autofill': {
      WebkitTextFillColor: 'text.neutral',
      color: 'text.neutral',
      boxShadow: {
        base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), inset 0 0 0 1000px {colors.AdornedInput.bg.default}',
      },
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
    '&:has(.c11n_adorned-input__input ~ button.c11n_adorned-input__adornment)': {
      paddingInlineEnd: 0,
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        '_focusWithin': {
          backgroundColor: 'bg.neutral',
          boxShadowColor: 'border.action.hero.selected.default',
        },
        '&:has(input:focus-visible)': {
          boxShadow: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
        '&:is(:active, [data-active]):not(:has(:is(button, [role="button"], a):is(:active, [data-active])))':
          {
            backgroundColor: 'bg.neutral',
            boxShadowColor: 'border.action.hero.selected.default',
          },
        'backgroundColor': {
          _hover: 'AdornedInput.bg.hover',
          _focus: 'bg.neutral',
        },
        'boxShadowColor': {
          _hover: 'AdornedInput.border.hover',
          _focus: 'border.action.hero.selected.default',
        },
        '&:is(:hover:active), &:is(:hover:focus)': {
          backgroundColor: 'bg.neutral',
        },
        '&:hover:is(:active, [data-active]):not(:has(:is(button, [role="button"], a):is(:active, [data-active])))':
          {
            boxShadowColor: 'AdornedInput.border.hover',
          },
      },
    },
    error: {
      true: {
        'backgroundColor': {
          base: 'AdornedInput.bg.error',
        },
        'boxShadowColor': {
          base: 'AdornedInput.border.error',
        },
        '_focusWithin': {
          backgroundColor: 'bg.neutral',
          boxShadowColor: 'AdornedInput.border.errorActive',
        },
        '&:is(:active, [data-active]):not(:has(:is(button, [role="button"], a):is(:active, [data-active])))':
          {
            backgroundColor: 'bg.neutral',
            boxShadowColor: 'AdornedInput.border.errorActive',
          },
      },
      false: {},
    },
    fluid: {
      true: {
        display: 'flex',
        width: '100%',
      },
      false: {
        display: 'inline-flex',
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        backgroundColor: {
          base: 'bg.invisible',
        },
        boxShadowColor: 'transparent.invisible',
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'obj.default',
        columnGap: 'tighter',
        paddingInline: 'default',
      },
      md: {
        borderRadius: 'obj.default',
        columnGap: 'tighter',
        paddingInline: 'default',
      },
      lg: {
        borderRadius: 'obj.default',
        columnGap: 'tighter',
        paddingInline: 'default',
      },
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'md',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      size: 'lg',
      readOnly: true,
      css: {
        paddingInline: 'none',
      },
    },
    {
      readOnly: true,
      disabled: false,
      css: {
        backgroundColor: {
          _active: 'bg.invisible',
          _focusWithin: 'bg.invisible',
          _hover: 'bg.invisible',
        },
        boxShadowColor: 'transparent.invisible',
      },
    },
    {
      error: true,
      disabled: false,
      css: {
        'backgroundColor': {
          _hover: 'AdornedInput.bg.errorHover',
        },
        'boxShadowColor': {
          _hover: 'AdornedInput.border.errorHover',
        },
        '&:is(:hover:active)': {
          backgroundColor: 'bg.neutral',
        },
        '&:hover:is(:active, [data-active]):not(:has(:is(button, [role="button"], a):is(:active, [data-active])))':
          {
            boxShadowColor: 'AdornedInput.border.errorHover',
          },
      },
    },
  ],
});
